import React from 'react';
import userManager from '../../utils/userManager';
import {CallbackComponent} from 'redux-oidc';

const CallBackComponent = props => {
    return(
        <CallbackComponent userManager={userManager} successCallback={props.successCallback}
                               errorCallback={props.successCallback}>
                {props.children}
            </CallbackComponent>
    );
};

export default CallBackComponent;